import { render, staticRenderFns } from "./AnswerMain.vue?vue&type=template&id=43698470&scoped=true&"
import script from "./AnswerMain.vue?vue&type=script&lang=js&"
export * from "./AnswerMain.vue?vue&type=script&lang=js&"
import style0 from "./AnswerMain.vue?vue&type=style&index=0&id=43698470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43698470",
  null
  
)

export default component.exports